import { Art } from "./Art";
import { DocumentLink } from "./DocumentLink";
import { t } from "../i18n";
import { Icons } from "../lib/icons";
import type { AnsweredField, BrandText, Locale } from "../types";

/**
 * Ekran sprawy domkniętej z wynikiem. „Zakończ odmową" i „Zakończ sukcesem"
 * dawały kandydatowi ten sam widok (nota końcowa procesu), więc odrzucony
 * czytał to samo co przyjęty. Teraz treść zależy od `outcome`: sukces dziękuje
 * i zostawia podpisane dokumenty pod ręką, odmowa mówi wprost i kieruje do obsługi.
 */
export function Finished({
  outcome,
  locale,
  documents = [],
  recordId,
  final,
  fail,
  bezInfoliniiCityDrive = false,
}: {
  outcome: "success" | "failed";
  locale: Locale;
  documents?: AnsweredField[];
  recordId?: string;
  /** Finał z szablonu marki — ekran sukcesu bez noty końcowej schematu. */
  final?: BrandText;
  /** Odmowa z szablonu marki: jej tekst i jej infolinia. */
  fail?: BrandText;
  /** Marka inna niż classic. Domyślna odmowa z i18n podaje infolinię City
   *  Drive — kandydat innej marki bez własnego tekstu dostaje wersję bez numeru. */
  bezInfoliniiCityDrive?: boolean;
}) {
  const failed = outcome === "failed";
  const marka = failed ? fail : final;
  const domyslnyTytul = failed
    ? bezInfoliniiCityDrive ? "finishedFailTitleGeneric" : "finishedFailTitle"
    : "finishedSuccessTitle";

  return (
    <div className="outcome" role={failed ? "alert" : "status"}>
      {failed ? (
        <div className="outcome__badge outcome__badge--stop">
          <Icons.cross size={30} />
        </div>
      ) : (
        <Art name="gotowe" size={180} className="outcome__art" />
      )}

      <h2 className="outcome__title">
        {marka?.title ?? t(domyslnyTytul, locale)}
      </h2>
      {marka?.text && <p className="outcome__text">{marka.text}</p>}

      {/* Odrzuconemu nie pokazujemy umowy — nie doszło do zatrudnienia. Przyjętemu
          zostawiamy podpisane dokumenty do pobrania. */}
      {!failed && recordId && documents.length > 0 && (
        <div className="outcome__docs kaskada">
          <p className="outcome__docstitle">{t("signedDocuments", locale)}</p>
          {documents.map((document, index) => (
            <DocumentLink
              key={document.key}
              recordId={recordId}
              docKey={document.key}
              locale={locale}
              style={{ "--i": index + 1 } as React.CSSProperties}
              className="btn btn--secondary outcome__doc"
            >
              <Icons.document size={18} />
              {document.title}
            </DocumentLink>
          ))}
        </div>
      )}
    </div>
  );
}
